module.exports = __webpack_public_path__ + "media/components/signup/static/xmark-c7f1c58005a220f82afa085678fc8ffa.svg";